"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeHoverLabels = exports.HoverLabels = void 0;
const ValueObjects_1 = require("../ValueObjects");
const MemoizedBoolean_1 = require("./MemoizedBoolean");
const ObservableEntity_1 = require("./ObservableEntity");
class HoverLabels extends ObservableEntity_1.ObservableEntity {
}
exports.HoverLabels = HoverLabels;
function makeHoverLabels() {
    return new HoverLabelsImp();
}
exports.makeHoverLabels = makeHoverLabels;
class HoverLabelsImp extends HoverLabels {
    constructor() {
        super(...arguments);
        this.labelLookup = new Map();
        this._show = false;
        this._position = ValueObjects_1.Vector2.Zero();
        this._label = "";
        this.memoizedAllow = new MemoizedBoolean_1.MemoizedBoolean(true, this.notify);
        this.setLabelForSceneObject = (sceneObjectID, label) => {
            this.labelLookup.set(sceneObjectID, label);
        };
        this.removeLabelForSceneObject = (sceneObjectID) => {
            this.labelLookup.delete(sceneObjectID);
        };
        this.getLabelFroSceneObject = (sceneObjectID) => {
            return this.labelLookup.get(sceneObjectID);
        };
        this.showLabelForSceneObject = (sceneObjectID, position) => {
            var _a;
            if (this.labelLookup.has(sceneObjectID)) {
                this.doShow((_a = this.labelLookup.get(sceneObjectID)) !== null && _a !== void 0 ? _a : "", position);
            }
            else {
                this.hideHoverLabel();
            }
        };
        this.hideHoverLabel = () => {
            if (!this._show)
                return;
            this._show = false;
            this._label = "";
            this._position = ValueObjects_1.Vector2.Zero();
            this.notify();
        };
    }
    get show() {
        return this._show;
    }
    get position() {
        return this._position;
    }
    get label() {
        return this._label;
    }
    get allowHoverLabels() {
        return this.memoizedAllow.val;
    }
    set allowHoverLabels(allow) {
        if (allow === this.memoizedAllow.val)
            return;
        this.memoizedAllow.val = allow;
        if (allow === false) {
            this.hideHoverLabel();
        }
    }
    doShow(label, pos) {
        if (!this.allowHoverLabels)
            return;
        if (label === this._label &&
            ValueObjects_1.Vector2.Equal(pos, this._position) &&
            this.show) {
            return;
        }
        this._label = label;
        this._position = pos;
        this._show = true;
        this.notify();
    }
}
